export const IMGS = {
  hero: "https://static.prod-images.emergentagent.com/jobs/9b9e0cf7-1501-4059-8d20-4c158267631b/images/764f4cad686528d6fea7a2b81e895fa50d4b2c18432e218b34243736d2279619.jpeg",
  plywoodStack:
    "https://images.pexels.com/photos/5089122/pexels-photo-5089122.jpeg?auto=compress&cs=tinysrgb&w=1200",
  planks:
    "https://images.pexels.com/photos/5089123/pexels-photo-5089123.jpeg?auto=compress&cs=tinysrgb&w=1200",
  workshop:
    "https://images.unsplash.com/photo-1787422429897-ad354751e61c?auto=format&fit=crop&w=1200&q=80",
  press:
    "https://static.prod-images.emergentagent.com/jobs/9b9e0cf7-1501-4059-8d20-4c158267631b/images/233e183a1f6aee85ca10ff40167b1969944f796cd0c0323ce3a0a5aecbd09f0e.jpeg",
  saw: "https://static.prod-images.emergentagent.com/jobs/9b9e0cf7-1501-4059-8d20-4c158267631b/images/66914741049f853449c6688ad68a743c1001dddbddc2b0dbacdcda2c9ae034c9.jpeg",
  banding:
    "https://static.prod-images.emergentagent.com/jobs/9b9e0cf7-1501-4059-8d20-4c158267631b/images/846889d9c1366c15d0a143d563096037c7eb37925c50ec27448e600c04dbb175.jpeg",
  carcass:
    "https://static.prod-images.emergentagent.com/jobs/9b9e0cf7-1501-4059-8d20-4c158267631b/images/fd9809ffd4788ecec2fc692deaa74ac91251e99febf2bd663ab4d5158052d90a.jpeg",
  hinge:
    "https://static.prod-images.emergentagent.com/jobs/9b9e0cf7-1501-4059-8d20-4c158267631b/images/3a1a83799a53183a32f9c66d52dda56e4f7b7352809397aec4ebb601e21d5ee5.jpeg",
  carpenter:
    "https://images.unsplash.com/photo-1611021061285-16c871740efa?auto=format&fit=crop&w=1200&q=80",
  marking:
    "https://images.unsplash.com/photo-1659930087003-2d64e33181f7?auto=format&fit=crop&w=1200&q=80",
  drawers:
    "https://images.unsplash.com/photo-1678108040468-0cc9addd984d?auto=format&fit=crop&w=1200&q=80",
  baskets:
    "https://images.unsplash.com/photo-1676907228185-6869277a9f8f?auto=format&fit=crop&w=1200&q=80",
};
